<script>
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Button from 'primevue/button';
import Chips from 'primevue/chips';

import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';
import GenericDateMaskV2 from '../../components/generic/GenericDateMaskV2.vue';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';

import { required, maxLength, minValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue';

export default{
  setup: () => ({ v$: useVuelidate() }),
  props: ['vesselProtocolId', 'documents', 'combinedNomenclature', 'plant', 'protocolNumber', 'statisticValue', 'protocolDate', 'direction', 'customer', 'vessel', 'quantity', 'netQuantity', 'product', 'origin', 'destination', 'voyageNumber', 'registryNumber', 'registryType', 'registryDate', 'isDisabled', 'fiscalDestination', 'mrn', 'vesselProtocolLots'],
  emits: ['onReportSaved'],
  
  components: {
    Button,
    GenericDateMaskV2,
    GenericCustomAutocompleteV2,
    GenericBooleanDropdown,
    ResponsiveButton
},
  data(){
    return {
      data: {},
      reports: [],
      categories: [],
      selectedCategory: null,
      selectedReport: null,
      filteredReports: [],
      newReport: {},
      newReportSubmitted: false,
      selectedReportFields: [],
      destinations: [],
      emailDialogVisible: false,
      checkedFlag: true,
      genericFields: [],
      mailAddresses: ""
    }
  },
  validations(){
    return {
      newReport: {},
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    },
    documentsSorted(){
      let sorted = [];
      if(this.documents && this.documents.length > 0){
        sorted = Array.from(this.documents);
        sorted.sort((a, b) => {
          return new Date(b.documentDate) - new Date(a.documentDate);
        })
      }
      return sorted;
    }
  },
  created(){
    this.reports = config.getConfiguration('VesselProtocol').reports;
    this.categories = [...new Set(this.reports.map(({category}) => category))].map((category) => ({label: category, value: category}));
  },
  mounted(){
    
  },
  watch: {
    'newReport.isValueReview'(){
      this.reloadFieldValues('isValueReview');
    },
    'newReport.isOriginalBillTransmission'(){
      this.reloadFieldValues('isOriginalBillTransmission');
    },
  },
  methods: {
    onCategorySelected(){
      this.selectedReport = null;
      this.filteredReports = this.reports.filter((item) => item.category === this.selectedCategory);
      this.filteredReports.forEach((item) => {item.label = item.code + ' - ' + item.description})
      this.selectedReportFields = [];
    },
    reloadFieldValues(dependence){
      if(this.selectedReport){
        let tempSelectedReportFields = this.reports.find((item) => item.code === this.selectedReport).fields;
        tempSelectedReportFields.forEach((field) => {
          if ((field.initialValue !== undefined) && (field.dependence === dependence)) {
            if (typeof field.initialValue === 'function'){
              this.newReport[field.name] = field.initialValue(this, this.newReport);
            } else {
              this.newReport[field.name] = field.initialValue;
            }
          }
        })
      }
    },
    loadField(){
      if(this.selectedReport){
        let tempSelectedReportFields = this.reports.find((item) => item.code === this.selectedReport).fields;
        
        tempSelectedReportFields.forEach((field) => {
          if(field.type === 'field'){
            this.newReport[field.name] = {};

            if(field.initialValue !== undefined){
              this.newReport[field.name].value = typeof field.initialValue === 'function' ? field.initialValue(this) : field.initialValue;
            }

            if(field.initialValueFrom !== undefined){
              this.newReport[field.name].from = typeof field.initialValueFrom === 'function' ? field.initialValueFrom(this) : field.initialValueFrom;
            }

            if(field.initialValueTo !== undefined){
              this.newReport[field.name].to = typeof field.initialValueTo === 'function' ? field.initialValueTo(this) : field.initialValueTo;
            }
          } else if(field.type === 'objectArray'){

            this.newReport[field.name] = [];
            for(let i = 0; i < field.inputNumber; i++){
              this.newReport[field.name][i] = {};
              field.children.forEach((child) => {
                this.newReport[field.name][i][child.name] = child.initialValue ? (typeof child.initialValue === 'function' ? child.initialValue(this) : child.initialValue) : null;
              })
            }

            if (field.destinationType){
              let filters = [
                {
                  operator: 'eq',
                  value: this.vesselProtocolId,
                  property: 'IdVesselProtocol'
                },
                {
                  operator: 'eq',
                  value: (field.destinationType === 'CEE' ? 'UE' : 'EST'),
                  property: 'CountryFlag'
                }
              ];
              let params = {
                  filter: JSON.stringify(filters),
              }
              Service.getVesselProtocolGoodsDestination(params, (response) => {
                if (response.success){
                  let destinations = response.data;
                  destinations.forEach((destination, index) => {
                    this.newReport[field.name][index]['destination'] = destination.country;
                    this.newReport[field.name][index]['quantity'] = destination.quantity;
                    this.newReport[field.name][index]['taxWarehouse'] = destination.fiscalDeposit;
                  })
                }
              })
            }
          } else {
            this.newReport[field.name] = null;
            if (field.initialValue !== undefined) {
              if (typeof field.initialValue === 'function'){
                if(field.initialValue.constructor.name === 'AsyncFunction'){
                  field.initialValue(this, this.newReport).then(t => {
                      this.newReport[field.name] = t;
                    }
                  );
                }else{
                  this.newReport[field.name] = field.initialValue(this, this.newReport);
                }
              } else {
                this.newReport[field.name] = field.initialValue;
              }
            }
          }
        })
        this.selectedReportFields = tempSelectedReportFields;
        this.genericFields = [];
      }
    },
    onReportSelected(){
      this.loadField();
    },
    saveCallback(isPreview){
      if(isPreview){
        return ({success, data, message}) => {
          if(success){
            if (data.id2){
              Service.getPreviewVesselProtocolReport({id: data.id, id2: data.id2}, this.previewCallback())
            }else {
              Service.getPreviewVesselProtocolReport({id: data.id}, this.previewCallback())
            }
          } else{
            this.$store.dispatch("generic/setLoading", false);
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        }
      } else {
        return ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          if(success){
            this.$emit('onReportSaved');
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        }
      }
    },
    previewCallback(){
      return (response) => {
        this.$store.dispatch("generic/setLoading", false);
        if(response.success){
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'Report-' + this.selectedReport + '.pdf');
          document.body.appendChild(fileLink);
          fileLink.click();
        }else{
          this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      }
    },
    sendEmail() {
      if(this.selectedReport === 52){
        this.$store.dispatch("generic/setLoading", true);
        Service.saveVesselProtocolReport52(({isPreview: false, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), ({success, data, message}) => {
          if(success){
            this.$emit('onReportSaved');
            Service.sendEmailReport52({idDocument: data.idSystemAttachment, idList: [data.idSystemAttachment, ...(this.documentsSorted.filter((document) => document.check).map((item) => item.id))]}, ({success, message}) => {
              this.$store.dispatch("generic/setLoading", false);
              
              if(success){
                this.$emit('onReportSaved');
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                this.emailDialogVisible = false;
              } else{
                this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
              }
            })
          }else {
            this.$store.dispatch("generic/setLoading", false);
            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        });
      }else if(this.selectedReport === 53){
        this.$store.dispatch("generic/setLoading", true);
        Service.saveVesselProtocolReport53(({isPreview: false, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), ({success, data, message}) => {
          if(success){
            
            this.$emit('onReportSaved');
            Service.sendEmailReport53({idDocument: data.idSystemAttachment, idList: [data.idSystemAttachment, ...(this.documentsSorted.filter((document) => document.check).map((item) => item.id))]}, ({success, message}) => {
              this.$store.dispatch("generic/setLoading", false);
              
              if(success){
                this.$emit('onReportSaved');
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                this.emailDialogVisible = false;
              } else{
                this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
              }
            })  
          }else {
            this.$store.dispatch("generic/setLoading", false);
            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        }); 
      }
    },
    addFieldFieldset(){
      this.genericFields.push({
        value: null,
        from: null,
        to: null
      })
    },
    onSelectQuantityChange(data){
      if(data.value != null && data.value.value != null)
        this.newReport.quantity = data.value.value;
    },
    handleReport(isPreview){
      this.newReport.fields = [];
      this.newReport.idVesselProtocol = this.vesselProtocolId;
      this.selectedReportFields.forEach((field) => {
        if(field.type === 'field' && (!field.direction || field.direction == this.direction) && this.newReport[field.name].value){
          this.newReport.fields.push(this.newReport[field.name])
        }

        if(field.type === 'addFields'){
          this.genericFields.forEach((field) => {
            this.newReport.fields.push(field);
          })
        }

      })
      this.$store.dispatch("generic/setLoading", true);

      switch (this.selectedReport) {
        case 7:
          Service.saveVesselProtocolReport7(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 11:
          Service.saveVesselProtocolReport11(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 12:
          Service.saveVesselProtocolReport12(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 13:
          Service.saveVesselProtocolReport13(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 14:
          Service.saveVesselProtocolReport14(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 16:
          Service.saveVesselProtocolReport16(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 23:
          Service.saveVesselProtocolReport23(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 24:
          Service.saveVesselProtocolReport24(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 28:
          Service.saveVesselProtocolReport28(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 30:
          Service.saveVesselProtocolReport30(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 31:
          Service.saveVesselProtocolReport31(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 33:
          Service.saveVesselProtocolReport33(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 36:
          Service.saveVesselProtocolReport36(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 37:
          Service.saveVesselProtocolReport37(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 38:
          Service.saveVesselProtocolReport38(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 39:
          Service.saveVesselProtocolReport39(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 40:
          Service.saveVesselProtocolReport40(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 41:
          Service.saveVesselProtocolReport41(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 42:
          Service.saveVesselProtocolReport42(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 44:
          Service.saveVesselProtocolReport44(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 45:
          Service.saveVesselProtocolReport45(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 47:
          Service.saveVesselProtocolReport47(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 52:
          Service.checkValueReview({idVesselProtocol: this.vesselProtocolId, reportCode: Number(this.selectedReport), isValueReview: this.newReport.isValueReview} , ({success, data, message}) => {
            this.$store.dispatch("generic/setLoading", false);

            if(success) {
              //data.openPopUp = false;
              if(data.openPopUp && !isPreview){
                this.emailDialogVisible = true;
                this.showAddress();
              }else{

                if(isPreview || (this.fiscalDestination != null && this.fiscalDestination != 'EST')){

                  this.$store.dispatch("generic/setLoading", true);             
                  Service.saveVesselProtocolReport52(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));

                }else{
                  this.$confirm.require({
                    message: this.$t('vesselProtocol.confirm_report52'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),  
                    rejectLabel: this.$t('no'),       
                    accept: () => {     
                        this.$store.dispatch("generic/setLoading", true);             
                        Service.saveVesselProtocolReport52(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
                    },
                    reject: () => {
                        this.$confirm.close();
                    }
                  });
                }               
              }
            }else{
              this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
          })
          break;
        case 53:
          Service.checkValueReview({idVesselProtocol: this.vesselProtocolId, reportCode: Number(this.selectedReport), isValueReview: this.newReport.isValueReview} , ({success, data, message}) => {
            this.$store.dispatch("generic/setLoading", false);

            if(success) {
              //data.openPopUp = false;
              if(data.openPopUp && !isPreview){
                this.emailDialogVisible = true;
                this.showAddress();
              }else{
                Service.saveVesselProtocolReport53(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
              }
            }else{
              this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
          })
          break;
        case 54:
          Service.saveVesselProtocolReport54(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 71:
          Service.saveVesselProtocolReport71(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 72:
          Service.saveVesselProtocolReport72(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        case 4:
          Service.saveVesselProtocolReport4(({isPreview: isPreview, data: this.newReport, section: this.selectedCategory, scope: this.selectedReport}), this.saveCallback(isPreview));
          break;
        default:
          break;
      }
    },



    toggleAddress(event){
      this.$refs.op.toggle(event)
    },
    showAddress(){
      let params = {
        reportCode:this.selectedReport ,
        idVesselProtocol: this.vesselProtocolId
      }
      this.mailAddresses = {value: "", escape: true};
      Service.getReportDataAddress(params, response => {
        if(response.success){
      this.mailAddresses.value = "<div style='width: 300px'>";

          let to = response.data.to;
          if(to && to.length > 0){
            this.mailAddresses.value += "TO: ";
            for(let i = 0; i<to.length; i++){
              this.mailAddresses.value += '<br> - ' + to[i];
            }
          }
          let cc = response.data.cc;
          if(cc && cc.length > 0){
            this.mailAddresses.value += "<br>CC: ";
            for(let i = 0; i<cc.length; i++){
              this.mailAddresses.value += '<br> - ' + cc[i];
            }
          }
          let ccn = response.data.bcc;
          if(ccn && ccn.length > 0){
            this.mailAddresses.value += "<br>CCN: ";
            for(let i = 0; i<ccn.length; i++){
              this.mailAddresses.value += '<br> - ' + ccn[i];
            }
          }
            this.mailAddresses.value += "</div>";
        }
      })
    },
    formatFileName(document){
      let name = document.fileName + document.fileExtension;
      if(document.description){
        name += ' - ' +document.description;
      }
      return name;
    }
  },
}

</script>

<template>
  <main>
    <Dialog :header="'Report ' + selectedReport + ' - Email'" v-model:visible="emailDialogVisible" modal closable :style="{width: '60vw'}" >
      <template #header>
          <h3>{{'Report ' + selectedReport + ' - Email'}}</h3>
          <Button icon="pi pi-info" severity="success" text raised rounded @click="toggleAddress" />
          <OverlayPanel ref="op">
              <div v-html="mailAddresses.value" />
            </OverlayPanel>
        </template>
      <div class="grid">
        <div class="field col-12">
          <hr :style="{marginTop: '0'}">
          <p>{{ this.$t('vesselProtocol.isValueRevisionConfirm') }}</p>
          <p>{{ this.$t('vesselProtocol.proceedToSend') }}</p>
          <hr :style="{marginBottom: '0'}">
        </div>
        <div class="field col-12">
          <b>{{ this.$t('vesselProtocol.documentsToAttach') }}</b>
          <p>
            <Checkbox
              v-model="checkedFlag"
              :disabled="true"
              :binary="true" />
            <label class="ml-2">{{ 'Report ' + selectedReport }}</label>
          </p>
          <template v-for="document in documentsSorted" :key="document.id">
            <p>
              <Checkbox
                v-model="document.check" 
                :binary="true" />
              <label class="ml-2">{{ formatFileName(document) }}</label>
            </p>
          </template>
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" class="p-button-outlined" @click="sendEmail" />
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-danger p-button-outlined" @click="emailDialogVisible = false" />
      </template>
    </Dialog>
    <div class="grid">
      <div class="col-12">
        <Fieldset :legend="$t('header')">
          <div class="grid">
            <div class="col-6">
              <label for="category" >{{ $t('vesselProtocol.typology') }}</label>
              <GenericCustomAutocompleteV2
                :onItemSelect="onCategorySelected"
                v-model="selectedCategory"
                name="category"
                id="category"
                :format="{ label: 'label', value: 'value' }"
                :staticOptions="categories"
                class="w-full p-inputtext-sm" />
            </div>
            <div class="col-6">
              <label for="report" >{{ $t('vesselProtocol.category') }}</label>
              <GenericCustomAutocompleteV2
                :onItemSelect="onReportSelected"
                v-model="selectedReport"
                name="report"
                id="report"
                :disabled="!selectedCategory"
                :format="{ label: 'label', value: 'code' }"
                :staticOptions="filteredReports"
                class="w-full p-inputtext-sm" />
            </div>
          </div>
        </Fieldset>
      </div>
      <div class="col-12">
          <Fieldset :legend="$t('form')">
            <div class="grid">
              <template v-for="field in selectedReportFields" :key="field.name">
                <div v-if="field.type !== 'selectQuantity'" :class="(field.type === 'field' && (!field.direction || field.direction == direction)) || field.type === 'objectArray'|| field.type === 'addFields' ? 'col-12' : 'col-12 lg:col-6'">
                  <label :class="{'p-error':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}" :for="field.name" v-if="field.type !== 'field' && field.type !== 'objectArray' && field.type !== 'selectQuantity'">{{ $t(field.label) }}</label>
                  <InputText 
                    v-if="field.type === 'string'"
                    :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                    :id="field.name"
                    type="text"
                    v-model="newReport[field.name]"
                    class="w-full p-inputtext-sm mt-1" />
                  <GenericDateMaskV2 
                    v-if="field.type === 'date'"
                    :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                    :id="field.name"
                    v-model="newReport[field.name]"
                    class="w-full mt-1" />
                  <InputNumber
                    v-if="field.type === 'number'"
                    :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                    :id="field.name"
                    :minFractionDigits="field.digits"
                    :maxFractionDigits="field.digits"
                    v-model="newReport[field.name]"
                    class="w-full p-inputtext-sm mt-1" />
                  <GenericCustomAutocompleteV2
                    v-if="field.type === 'select'"
                    v-model="newReport[field.name]"
                    :id="field.name"
                    :format="field.format"
                    :api="field.selectApi"
                    :staticOptions="field.staticOptions"
                    class="w-full p-inputtext-sm" />
                  <Chips
                    v-if="field.type === 'stringArray'"
                    :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                    :id="field.name"
                    v-model="newReport[field.name]"
                    class="w-full p-fluid"
                    inputClass="mt-1" />
                  <GenericBooleanDropdown 
                    v-if="field.type === 'boolean'"
                    v-model="newReport[field.name]"
                    :id="field.name"
                    class="w-full" />
                  <Textarea 
                    v-if="field.type === 'textarea'"
                    :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                    :id="field.name"
                    type="text"
                    v-model="newReport[field.name]"
                    class="w-full mt-1 h-10rem"
                    />
                  <template v-if="field.type === 'field' && (!field.direction || field.direction == direction)">
                    <Fieldset :legend="$t(field.label)">
                      <div class="grid">
                        <div class="col-12 lg:col-4">
                          <label>{{ $t('value') }}</label>
                          <InputText
                            type="text"
                            :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                            v-model="newReport[field.name]['value']"
                            class="w-full p-inputtext-sm mt-1" />
                        </div>
                        <div class="col-12 lg:col-4">
                          <label>{{ $t('from') }}</label>
                           <InputText 
                            type="text"
                            :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                            v-model="newReport[field.name]['from']"
                            class="w-full p-inputtext-sm mt-1" />
                        </div>
                        <div class="col-12 lg:col-4">
                          <label>{{ $t('to') }}</label>
                           <InputText 
                            type="text"
                            :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                            v-model="newReport[field.name]['to']"
                            class="w-full p-inputtext-sm mt-1" />
                        </div>
                      </div>
                    </Fieldset>
                  </template>
                  <template v-if="field.type === 'objectArray'">
                    <Fieldset :legend="$t(field.label)" :toggleable="field.collapsible">
                      <div class="grid">
                        <template v-for="_, index in field.inputNumber" :key="index">
                          <template v-for="child in field.children" :key="child.name">
                            <div class="col-12 lg:col-4">
                              <label>{{ $t(child.label) }}</label>
                              <InputText 
                                v-if="child.type === 'string'"
                                type="text"
                                v-model="newReport[field.name][index][child.name]"
                                class="w-full p-inputtext-sm mt-1" />
                              <InputNumber
                                v-if="child.type === 'number'"
                                v-model="newReport[field.name][index][child.name]"
                                class="w-full p-inputtext-sm mt-1" />
                              <GenericDateMaskV2 
                                v-if="child.type === 'date'"
                                v-model="newReport[field.name][index][child.name]"
                                class="w-full mt-1" />
                              <Textarea 
                                v-if="child.type === 'textarea'"
                                type="text"
                                v-model="newReport[field.name][index][child.name]"
                                class="w-full mt-1 h-5rem"
                                />
                            </div>
                          </template>
                        </template>
                      </div>
                    </Fieldset>
                  </template>
                  <template v-if="field.type === 'addFields'">
                      <Button :label="$t('btn.add')" icon="pi pi-plus" class="p-button mr-2" @click="addFieldFieldset" />
                      <Fieldset v-for="(f, index) in genericFields" :key="'generic_field_'+index" class="mt-2">
                        <div class="grid">
                          <div class="col-12 lg:col-4">
                            <label>{{ $t('value') }}</label>
                            <InputText
                              type="text"
                              v-model="f.value"
                              class="w-full p-inputtext-sm mt-1" />
                          </div>
                          <div class="col-12 lg:col-4">
                            <label>{{ $t('from') }}</label>
                              <InputText 
                              type="text"
                              v-model="f.from"
                              class="w-full p-inputtext-sm mt-1" />
                          </div>
                          <div class="col-12 lg:col-4">
                            <label>{{ $t('to') }}</label>
                              <InputText 
                              type="text"
                              v-model="f.to"
                              class="w-full p-inputtext-sm mt-1" />
                          </div>
                        </div>
                      </Fieldset>
                  </template>
                  <div v-if="(v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted) || v$.newReport[field.name] && v$.newReport[field.name].$pending.$response">
                    <small class="p-error" v-for="error in v$.newReport[field.name] && v$.newReport[field.name].$silentErrors" :key="error.$validator" >
                        {{error.$message}}
                    </small>
                  </div>
                </div>
                <div v-else-if="field.type === 'selectQuantity' && vesselProtocolLots.length > 1" :class="(field.type === 'field' && (!field.direction || field.direction == direction)) || field.type === 'objectArray'|| field.type === 'addFields' ? 'col-12' : 'col-12 lg:col-6'">
                  <label :class="{'p-error':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}" :for="field.name">{{ $t(field.label) }}</label>
                  <GenericCustomAutocompleteV2
                    v-model="newReport[field.name]"
                    :onItemSelect="onSelectQuantityChange"
                    :id="field.name"
                    :format="field.format"
                    :api="field.selectApi + '?idVesselProtocol='+vesselProtocolId"
                    :staticOptions="field.staticOptions"
                    class="w-full p-inputtext-sm" />
                </div>
              </template>
              <div class="col-12">
                <Button :label="$t('btn.preview')" icon="pi pi-file-pdf" class="p-button-danger mr-2" @click="handleReport(true)" v-if="selectedReport" />
                <Button :label="$t('btn.save')" icon="pi pi-save" class="p-button-success" @click="handleReport(false)" :disabled="!uiPermissions('reportVesselProtocolSaveButton').isEnabled || isDisabled" v-if="!uiPermissions('reportVesselProtocolSaveButton').isHidden && selectedReport"/>
              </div>
            </div>
          </Fieldset>
      </div>
    </div>
  </main>
</template>